/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Fokus_S2Inputs */

const en_tut_fokus_s2 = /** @type {(inputs: Tut_Fokus_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a room: open **Fokus bersama**, set **Fokus (menit)**, **Istirahat (menit)**, and the number of cycles, then **Mulai sesi**. The timer runs on server time, so it stays accurate even when your tab sleeps.`)
};

const id_tut_fokus_s2 = /** @type {(inputs: Tut_Fokus_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk satu ruang: buka **Fokus bersama**, atur **Fokus (menit)**, **Istirahat (menit)**, dan **Jumlah siklus**, lalu **Mulai sesi**. Timer berjalan di jam server, jadi tetap tepat walau tab Anda tertidur.`)
};

/**
* | output |
* | --- |
* | "For a room: open **Fokus bersama**, set **Fokus (menit)**, **Istirahat (menit)**, and the number of cycles, then **Mulai sesi**. The timer runs on server tim..." |
*
* @param {Tut_Fokus_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_fokus_s2 = /** @type {((inputs?: Tut_Fokus_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Fokus_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_fokus_s2(inputs)
	return en_tut_fokus_s2(inputs)
});